import React from 'react';
import {createRoot} from 'react-dom/client';
import './index.css';
import App from './App.jsx';

document.addEventListener("DOMContentLoaded", function() {
  const domNode = document.getElementById('senso-account-root');
  const root = createRoot(domNode);
  root.render(
    <React.StrictMode>
      <App/>
    </React.StrictMode>
  )
});